import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUndo } from '@fortawesome/free-solid-svg-icons';
import { ACCOUNT_TYPES, ACCOUNT_TIERS, SERVICE_FILTERS } from '../constants';

export function AccountsFilters({ filters, onChange, onSearch, onReset }) {
    return (
        <div className="filters-panel">
            <div className="row g-3 align-items-end">
                <div className="col">
                    <label className="fw-bold mb-1 d-block text-white-50" style={{ fontSize: '0.85rem' }}>Tipo de cuenta</label>
                    <select
                        className="form-select bg-dark text-white border-secondary py-2"
                        value={filters.type}
                        onChange={(e) => onChange('type', e.target.value)}
                    >
                        <option value="">Todos</option>
                        {ACCOUNT_TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
                    </select>
                </div>
                <div className="col">
                    <label className="fw-bold mb-1 d-block text-white-50" style={{ fontSize: '0.85rem' }}>Tier</label>
                    <select
                        className="form-select bg-dark text-white border-secondary py-2"
                        value={filters.tier}
                        onChange={(e) => onChange('tier', e.target.value)}
                    >
                        <option value="">Todos</option>
                        {ACCOUNT_TIERS.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
                    </select>
                </div>
                <div className="col">
                    <label className="fw-bold mb-1 d-block text-white-50" style={{ fontSize: '0.85rem' }}>Servicio</label>
                    <select
                        className="form-select bg-dark text-white border-secondary py-2"
                        value={filters.service}
                        onChange={(e) => onChange('service', e.target.value)}
                    >
                        <option value="">Todos</option>
                        {SERVICE_FILTERS.map((s) => <option key={s.value} value={s.value}>{s.label}</option>)}
                    </select>
                </div>
            </div>
            <div className="row g-3 align-items-end mt-0">
                <div className="col">
                    <label className="fw-bold mb-1 d-block text-white-50" style={{ fontSize: '0.85rem' }}>Prefix</label>
                    <input
                        type="text"
                        className="form-control bg-dark text-white border-secondary py-2"
                        value={filters.prefix}
                        placeholder="Ej. TST"
                        onChange={(e) => onChange('prefix', e.target.value)}
                    />
                </div>
                <div className="col">
                    <label className="fw-bold mb-1 d-block text-white-50" style={{ fontSize: '0.85rem' }}>Nombre de cuenta</label>
                    <input
                        type="text"
                        className="form-control bg-dark text-white border-secondary py-2"
                        value={filters.search}
                        placeholder="Buscar por nombre..."
                        onChange={(e) => onChange('search', e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') onSearch(); }}
                    />
                </div>
                <div className="col-auto d-flex gap-2">
                    <button className="btn btn-ink-search" onClick={onSearch}>
                        <FontAwesomeIcon icon={faSearch} className="me-1" /> Buscar
                    </button>
                    <button className="btn btn-outline-secondary border-secondary text-white-50 px-3" onClick={onReset}>
                        <FontAwesomeIcon icon={faUndo} className="me-1" /> Limpiar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AccountsFilters;